export default __webpack_public_path__ + "static/media/npsThumbnail.0c79d279.png";